<template>
    <div
        class="tw-my-4 tw-flex tw-justify-between md:tw-w-3/4 tw-mx-auto"
    >
        <div
            class="tw-w-1/2 tw-text-center"
            v-html="label"
        />
        <div class="controls tw-cursor-pointer tw-select-none tw-w-1/2">
            <button @click="decrease" class="button">
                <span>-</span>
            </button>
            <input
                class="tw-w-full"
                :name="name"
                disabled
                maxlength="2"
                size="2"
                :min="min"
                type="number"
                v-model.number="model"
            />
            <button @click="increase" class="button">
                <span>+</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            min: {
                type: Number,
                required: true
            },
            value: {
                type: Number,
                required: true,
            },
            label: {
                type: String,
                required: true
            }
        },
        methods: {
            decrease() {
                if (this.value <= this.min) {
                } else {
                    this.$emit('input', this.value - 1);
                }
            },
            increase() {
                this.$emit('input', this.value + 1);
            },
        },
        computed: {
            model: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                },
            }
        },
    }
</script>

<style scoped>
    .controls {
        display: flex;
        align-items: center;
    }

    .button {
        font-size: 20px;
        color: #AB474A;
        border: 2px solid #E15D61FF;
        border-radius: 100%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: lighter;
    }


    input[type=number] {
        -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input {
        display: flex;
        align-items: center;
        border: none;
        height: 40px;
        width: 40px;
        font-size: 20px;
        text-align: center;
        font-weight: lighter;
    }
    input:disabled {
        opacity: 1;
        background: transparent;
    }
</style>